import React from 'react'
import { createContainer } from 'unstated-next'
import { useDisableCtrlFetch } from 'utils/hooks'
import { useGetMessages } from 'pages/admin/supplierMessaging/hooks'

export type UtilsContainerState = {
  redirectURLState?: string
}

const useUtils = (initialState?: UtilsContainerState) => {
  //Initial URL
  const [redirectURL, setRedirectURL] = React.useState(initialState?.redirectURLState ?? window.location.pathname)

  //Singleton State for <Loader> component
  const [singletonLoader, setSingletonLoader] = React.useState('')

  //Enable fetching when CTRL is not held down
  const { ctrlFetchEnabled } = useDisableCtrlFetch()

  //Fetch Supplier Message API
  const { getMessagesStatus, messagesData, getMessagesError } = useGetMessages('Supplier')

  return {
    redirectURL,
    setRedirectURL,
    singletonLoader,
    setSingletonLoader,
    ctrlFetchEnabled,
    getMessagesStatus,
    messagesData,
    getMessagesError,
  }
}

export const UtilsContainer = createContainer(useUtils)
